<template>
  <div class="history-al">
    <div class="history" style="background-size:25%; min-height: 330px;">
      <h3>
        <span>发展历程</span>／History
      </h3>

      <div id="tabsSelectBox" style="margin-top: 50px;">
        <img src="@/assets/images/new-img/history.png" style="width:100%" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "history",
  data() {
    return {
      currentPage: "0"
    };
  },
  methods: {
    handleClick() {
      this.currentPage = event.target.dataset.index;
    }
  }
};
</script>

<style lang="scss" scoped>
.pT20 {
  padding-top: 20px; 
}
.history-al {
  padding: 50px 0;
  width: 100%;
  display: inline-block;
}
.history {
  width: 1000px;
  margin: 0 auto;
}
.history h3 {
  margin: 0;
  padding: 0;
  font-size: 18px;
  text-align: center;
}
.history h3 span {
  font-size: 30px;
}
.tabsSelectBar > div {
  position: relative;
  height: 55px;
  line-height: 55px;
  font-size: 20px;
  border-bottom: 3px solid #f1f1f1;
  color: #383838;
  text-align: center;
  display: inline-block;
  margin-left: -4px;
}
.tabsSelectBar > div div {
  display: none;
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-left: -6px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 3px solid #45ba77;
}
.tabsSelectBar > div.active {
  border-bottom: 3px solid #45ba77;
  color: #45ba77;
}
.tabsSelectBar > div.active div {
  display: block;
}
.w20 {
  width: 20%;
  cursor: pointer;
}
.w60 {
  width: 60%;
}
.w50 {
  width: 50px;
}
.monthPoint {
  border-right: 1px dashed #45ba77;
  position: relative;
  .circle {
    width: 8px;
    height: 8px;
    border-radius: 4px;
    border: 1px solid #a6e2bf;
    background-color: #fff;
    position: absolute;
    right: -5px;
    div {
      width: 4px;
      height: 4px;
      border-radius: 2px;
      background-color: #45ba77;
      margin: 1px auto;
    }
  }
  .coverLine {
    background-color: #fff;
    position: absolute;
    right: -1px;
    width: 3px;
  }
}
.posiT0 {
  position: absolute;
  top: 0;
}
.T8 {
  top: 8px;
}
.T0H8 {
  top: 0px;
  height: 8px;
}
.pT20L20 {
  padding: 20px 0 0 20px;
}
.pL20 {
  padding-left: 20px;
}
table {
  margin-top: 30px;
  background-position: 158px 6px;
  max-width: 100%;
  background-color: transparent;
  border-collapse: collapse;
  border-spacing: 0;
}
</style>